import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_5123_11003)\"><path d=\"M1.66667 4.33333C2.58714 4.33333 3.33333 3.58714 3.33333 2.66667C3.33333 1.74619 2.58714 1 1.66667 1C0.746192 1 0 1.74619 0 2.66667C0 3.58714 0.746192 4.33333 1.66667 4.33333Z\" fill=\"currentColor\"></path><path d=\"M5.66667 3.33333H15.3333C15.5101 3.33333 15.6797 3.2631 15.8047 3.13807C15.9298 3.01305 16 2.84348 16 2.66667C16 2.48986 15.9298 2.32029 15.8047 2.19526C15.6797 2.07024 15.5101 2 15.3333 2H5.66667C5.48986 2 5.32029 2.07024 5.19526 2.19526C5.07024 2.32029 5 2.48986 5 2.66667C5 2.84348 5.07024 3.01305 5.19526 3.13807C5.32029 3.2631 5.48986 3.33333 5.66667 3.33333Z\" fill=\"currentColor\"></path><path d=\"M1.66667 9.67025C2.58714 9.67025 3.33333 8.92406 3.33333 8.00358C3.33333 7.08311 2.58714 6.33691 1.66667 6.33691C0.746192 6.33691 0 7.08311 0 8.00358C0 8.92406 0.746192 9.67025 1.66667 9.67025Z\" fill=\"currentColor\"></path><path d=\"M15.3333 7.33691H5.66667C5.48986 7.33691 5.32029 7.40715 5.19526 7.53218C5.07024 7.6572 5 7.82677 5 8.00358C5 8.18039 5.07024 8.34996 5.19526 8.47499C5.32029 8.60001 5.48986 8.67025 5.66667 8.67025H15.3333C15.5101 8.67025 15.6797 8.60001 15.8047 8.47499C15.9298 8.34996 16 8.18039 16 8.00358C16 7.82677 15.9298 7.6572 15.8047 7.53218C15.6797 7.40715 15.5101 7.33691 15.3333 7.33691Z\" fill=\"currentColor\"></path><path d=\"M1.66667 14.9964C2.58714 14.9964 3.33333 14.2502 3.33333 13.3298C3.33333 12.4093 2.58714 11.6631 1.66667 11.6631C0.746192 11.6631 0 12.4093 0 13.3298C0 14.2502 0.746192 14.9964 1.66667 14.9964Z\" fill=\"currentColor\"></path><path d=\"M15.3333 12.6631H5.66667C5.48986 12.6631 5.32029 12.7333 5.19526 12.8583C5.07024 12.9834 5 13.1529 5 13.3298C5 13.5066 5.07024 13.6761 5.19526 13.8012C5.32029 13.9262 5.48986 13.9964 5.66667 13.9964H15.3333C15.5101 13.9964 15.6797 13.9262 15.8047 13.8012C15.9298 13.6761 16 13.5066 16 13.3298C16 13.1529 15.9298 12.9834 15.8047 12.8583C15.6797 12.7333 15.5101 12.6631 15.3333 12.6631Z\" fill=\"currentColor\"></path></g><defs><clipPath id=\"clip0_5123_11003\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'viewIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "white",
  },
  size: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})